// Imports de librerías
import { Box3, Group, Raycaster, Vector2 } from 'three';
import gsap, { Power2, Power3 } from 'gsap';
import BezierEasing from 'bezier-easing';

// Imports internos
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Image from '../_app/cuchillo/3D/Image';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { isMobile, isSmartphone } from '../_app/cuchillo/core/Basics';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import Header from '../layout/Header';


export default class CarruselSlider extends Group {
    static instance = null;
    static _alpha = 1;
    static data = {};
    static radio = 0;
    static speed = 0;
    static radioShow = 0;
    static radioOffset = 0;
    static radioHide = 0;
    static rotationX = Functions.degreesToRadians(-10);
    static rotationHide = Functions.degreesToRadians(-10);
    static rotationShow = isSmartphone? Functions.degreesToRadians(20) : Functions.degreesToRadians(35);
    
    static easing = BezierEasing(0.69, 0.27, 0.43, 0.56);
    static easingX = BezierEasing(0.85, 0.45, 0.84, 0.54);

    static actual = 0;

    static get alpha() {
        return this._alpha;
    }

    static set alpha(value) {
        this._alpha = value;
        const instance = this.getInstance();
       /* if (instance?.scroller) {
            instance.scroller._items.forEach(item => {
                item.image.material.uniforms.opacity.value = value;
            });
        }*/
    }
                
    static getInstance(dom) {
        if (!this.instance) {
            this.instance = new CarruselSlider(dom);
        }
        return this.instance;
    }


    constructor(dom) {
        if (CarruselSlider.instance) return CarruselSlider.instance;
        super();

        this.dom = dom;
        this.meshes = [];
        this.total = 0;
        this.actual = null;
        this.isShow = false;
        this.visible = false;
        this.raycaster = new Raycaster();
        this.pointer = new Vector2();
        this.src404 = this.dom.dataset.src;
        
        this.radio = 0;
        this.radioTo = 0;
        this.radioShow = 0;
        this.radioHide = 0;
        this.scaleImage = 1;
        
        CarruselSlider.actual = 0;
        CarruselSlider.instance = this;

        this.load();
        this.setupRaycaster();
        this.resize();
    }

    load() {
        this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_X, {
            domResize: this.dom,
            container: this.dom,
            multiplicator: 1,
            itemClass: CarruselSlider__Item,
            minSpeed: 2,
            inverted: false,
            gap: 0,
            hasVirtuaScroll: true,
        });
    }

    setupRaycaster() {
        this.meshes = this.scroller._items
            .map(item => item?.image?.mesh)
            .filter(Boolean);
    }

    show(__texts) {
        this.actual = 0;
        this.texts = __texts;

        gsap.killTweensOf(CarruselSlider);

        this.scroller.start();
        this.scroller.show();

        this.visible = true;
        this.isShow = true;
        this.alpha = 0;

        WebGLSketch.setBloomStrength(0);

        for(let i=0; i<this.scroller.total_items; i++) {
            this.scroller._items[i].showAlpha();
        }

        CarruselSlider.radioTo = CarruselSlider.radioHide;
        this.scroller.options.minSpeed = 120;
      
        gsap.to(CarruselSlider, {radioTo:CarruselSlider.radioShow, rotationX:CarruselSlider.rotationShow, ease:Power3.easeOut, duration:.8, delay:0});
        gsap.to(this.scroller.options,{minSpeed:isSmartphone? 0 : 0, ease:Power2.easeOut, duration:2, delay:0, onComplete:()=> {
            this.enabled = true;
        }});

        
                
        gsap.to(CarruselSlider, { alpha: 1, ease: Power2.easeIn, duration: 0.1 });
    }

    showText(__n) {
        if(__n == CarruselSlider.actual) return;

        const itemOut = this.texts[CarruselSlider.actual];
        const itemIn = this.texts[__n];

        gsap.killTweensOf([itemIn, itemOut]);

        itemOut.style.pointerEvents = "none";
        gsap.to(itemOut, {opacity:0, duration:.2});
        itemIn.style.pointerEvents = "all";
        gsap.to(itemIn, {opacity:1, duration:.1, delay:.01});
        //gsap.to(itemIn, {opacity:1, duration:.5, delay:.05});

        
        CarruselSlider.actual = __n;
        //
    }

    hide() {
        this.isShow = false;
        this.enabled = false;
        
        gsap.killTweensOf([CarruselSlider,this.scroller.options]);

        for(let i=0; i<this.scroller.total_items; i++) {
            this.scroller._items[i].hideAlpha(0);
        }

        gsap.to(this.scroller.options, {minSpeed: 80, ease: Power3.easeOut, duration: 1, delay:0 });
        gsap.to(CarruselSlider, {radioTo:0, rotationX:CarruselSlider.rotationHide, ease:Power2.easeIn, duration:.8, delay:0, onComplete:()=> {
            this.visible = false;
            this.scroller.hide();
        }});
       /* gsap.to(CarruselSlider, {
            alpha: 0,
            ease: Power2.easeIn,
            duration: 0.01,
            delay: 0.7,
            onComplete: () => {
                this.visible = false;
                this.scroller.hide();
            },
        });*/
    }

    checkHover() {
        if(!this.isShow) return;

        const mouse = Interaction.positions.mouse;
        this.pointer.set(
            (mouse.x / window.innerWidth) * 2 - 1,
            -(mouse.y / window.innerHeight) * 2 + 1
        );

        this.raycaster.setFromCamera(this.pointer, WebGLSketch.camera);
        const intersects = this.raycaster.intersectObjects(this.meshes, false);

        if (intersects.length > 0) {
            const uuid = intersects[0].object.uuid;
            if (this.actual !== uuid) {
                this.actual = uuid;
                const { title, url, isShow } = CarruselSlider.data[uuid];
                //if(isShow) this.link.show(title, url);
            }
        } else {
            this.actual = null;
        }
    }

    loop() {
        if (!this.scroller.enabled) return;
       
        CarruselSlider.speed = this.scroller.speed * 1.9;
        CarruselSlider.radio = CarruselSlider.radioTo - CarruselSlider.speed;
        
        this.position.x = -CarruselSlider.radioOffset;
        this.rotation.x = CarruselSlider.rotationX;
        
        this.scroller.loop();
        this.checkHover();
    }

    resize() {
        CarruselSlider.radioShow = isSmartphone? Metrics.WIDTH * 1.5 : Metrics.WIDTH * 1;
        CarruselSlider.radioHide = 0;
        CarruselSlider.radioOffset = isSmartphone? CarruselSlider.radioShow : CarruselSlider.radioShow * 1.1

        if(this.isShow) {
            CarruselSlider.radioTo = CarruselSlider.radioShow;
        } else {
            CarruselSlider.radioTo = CarruselSlider.radioHide;
        }
        
        this.position.x = -CarruselSlider.radio * .95;
        this.position.y = isSmartphone? -Metrics.CENTER_Y * .40 : -Metrics.CENTER_Y * .80;
        this.scroller.resize();
    }
}


class CarruselSlider__Item extends InfiniteScroll__Item {
    group = new Group();
    pivot = new Group();

    domImage;
    isReset = false;
    isShow = false;
    isBlocked = false;
    image;
    title;
    url;
    refWidth;
    offset = {};
    offsetPositionY = .55;
    modAspectRatio = 1;
    modSpeed = 1.859;

    alpha = 0;
    
    distance = isSmartphone? 45 : 25;

    angleLimit = Functions.degreesToRadians(this.distance);
    angleOffset = isSmartphone? -Functions.degreesToRadians(10) : -Functions.degreesToRadians(10);
    angleStart = Functions.degreesToRadians(-90);
    angleEnd = Functions.degreesToRadians(180);

    constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
        super(__d, __i, __axis, false);
        this.domImage = GetBy.selector("span", this.dom)[0];
        this.image = new Image({dom:this.domImage, hasFreePosition:true, hasBlur:true, fit:"contain"});
        this.title = this.domImage.dataset.title;
        this.url = this.domImage.dataset.url;
        
        // Calcular la altura real de la imagen
        const bbox = new Box3().setFromObject(this.image.mesh);
        const height = bbox.max.y - bbox.min.y;

        // Mover la imagen dentro del pivot para que su bottom quede en Y=0
        this.image.position.y = height / 2;

        this.pivot.add(this.image);
        this.group.add(this.pivot);

        CarruselSlider.getInstance().add(this.group);
        CarruselSlider.data[this.image.mesh.uuid] = this;

        this.image.visible = false;

        this.resize();
        this.reset();
    }

    reset() {
        if(this.isReset) return;
        this.isReset = true;
        
        this.offset = {
            y: 0,
            x: 0,
            rotation: {
                y0: Maths.maxminRandom(12, 4),
                x0: Maths.maxminRandom(12, 4),
                z0: Maths.maxminRandom(4, 2),
                y1: Maths.maxminRandom(12, 4),
                x1: Maths.maxminRandom(12, 4),
                z1: Maths.maxminRandom(4, 2),
                yMod: Math.random() > .5? 1 : -1,
                xMod: Math.random() > .5? -1 : 1,
                zMod: Math.random() > .5? -1 : 1,
            }
        }
    }

    drawHook() {
       this.move();
    }

    hideAlpha(delay=0) {
        this.alpha = 0;
        

        setTimeout(()=> {
            this.group.visible = false;
        }, delay + 600 + Maths.maxminRandom(100, 0));
    }

    showAlpha() {
        setTimeout(()=> {
            this.group.visible = true;
        }, Maths.maxminRandom(600, 0));
    }

    show() {
        if (this.isShow) return;

        this.isShow = true;
        this.isReset = false;
        this.image.visible = true;
        this.image.play();
    }

    hide() {
        if (!this.isShow) return;

        this.reset();
        this.isShow = false;
        this.image.pause();
        this.image.visible = false;
    }

    move() {
        if(this.isBlocked) return;

        this.pivot.position.x = CarruselSlider.radio;

        let generalRotation = Maths.lerp(0, this.angleLimit, this.progress) + this.angleOffset;   
        
        if(generalRotation > this.angleEnd || generalRotation < this.angleStart) {
            this.hide();
            return;
        } else {
            this.show();

            if(this.progress > 0 && this.progress < 1 && CarruselSlider.getInstance().enabled) {
                Header.changeTitle(this.title, this.url);
                CarruselSlider.getInstance().showText(this.indice);    
            }
        }

        generalRotation = generalRotation + this.angleOffset;
        const modBlur = this.progress > 1? 1 : 2; 
        const blur = Maths.lerp(0, 9, Math.abs(generalRotation * .9)) * .001;//Maths.lerp(0, 4, CarruselSlider.easing(Math.abs(progressRotation) * .5)); 
        

        if(this.image) {
            this.image.material.uniforms.blurAmount.value = blur * modBlur;
            this.group.rotation.y = generalRotation;
            this.pivot.rotation.y = -this.group.rotation.y;
            this.image.rotation.x = -CarruselSlider.rotationX;
            this.image.rotation.z = -CarruselSlider.speed * .0002;
        }
    }

    dispose() {
        super.dispose();
    }

    resize() {
        super.resize();
            
        if(this.image) {
            if(Metrics.WIDTH < Sizes.SMARTPHONE) {
                this.modSpeed = .8;
            } else {
                this.modSpeed = 2.859;
            }
            
            this.image.resize();

            const ratio = Metrics.WIDTH / Metrics.HEIGHT;
            
            this.xImageOffset = this.xImage * .5;

            this.modAspectRatio = 0.5 + (ratio - 1.0) * ((1.0 - 0.5) / (1.6 - 1.0));
            this.modAspectRatio = Math.max(0.5, ratio * .5);
            this.offsetPositionY = .55 + (this.modAspectRatio - .5) * .25;

            this.pivot.position.x = CarruselSlider.getInstance().radio;
        }
    }
}